module.exports = __webpack_public_path__ + "static/media/guideCSVImage.2b5e1947.png";